import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getOrganization } from "@/api/organizationApi";
import { organizationKeys } from "@/api/organizationKeys";
import { apiErrorMeta } from "@/lib/apiErrorHandling";
import type { OrganizationDetail } from "@/types/api/organization";

type UseOrganizationOptions = {
  enabled?: boolean;
};

export function useOrganization(options?: UseOrganizationOptions) {
  return useQuery<OrganizationDetail>({
    queryKey: organizationKeys.detail(),
    queryFn: getOrganization,
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    meta: apiErrorMeta.organizationLoad,
  });
}
